import {getData, mhandHttps} from "../../utils.js";
import {filters} from "../../filters.js";

const filterTypes = [
    // {
    //     "id": "brand",
    //     "label": "Бренд",
    // },
    {
        "id": "material",
        "label": "Материал"
    },
    {
        "id": "color",
        "label": 'Цвет',
    },
    {
        "id": "size",
        "label": "Размер",
    },
]


export async function addFilters() {
    console.log(1);
    for (const filterType of filterTypes) {
        try {
            const data = await getData(`${mhandHttps}api/characteristic-filters/?type__name=${filterType.label}`);
            createFilerSection(filterType, data.results);
        } catch (error) {
            console.error(`Ошибка при получении данных для фильтра "${filterType.label}":`, error);
        }
    }
}

function createFilerSection(filterType, filterChoices) {
    const container = document.querySelector('.__filter_menu_container')
    const filterItemContainer = document.createElement('div')
    filterItemContainer.classList.add("filters-block__menu__filters__list")

    const filterItemTitle = `<span>${filterType.label}</span>`;

    container.appendChild(filterItemContainer);
    filterItemContainer.innerHTML = filterItemTitle;

    filterChoices.forEach(choice => {
        const choiceLabel = document.createElement("label");
        choiceLabel.classList.add('custom-radio-label');
        choiceLabel.setAttribute("for", `catalog-sort-radio-${choice.id}`);

        choiceLabel.innerHTML = `
            <input type="radio" 
                name="catalog-sort-by-${filterType.id}"
                id="catalog-sort-radio-${choice.id}"
                class="__filter_elem"
                data-query="${filterType.id}"
                data-value="${choice.id}"
            >${choice.value}
        `;

        filterItemContainer.appendChild(choiceLabel);
    })
    filters()
}